// Logout.js - Complete Safe Version

import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';

const Logout = ({ onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { shopId } = useParams();

  const [showingPopup, setShowingPopup] = useState(false);
  const hasShownPopupRef = useRef(false);

  // ✅ Determine previous page from URL (shop prefix ya root)
  const getFallbackPath = () => {
    // Agar URL mein shopId hai to shop dashboard pe bhejo
    if (shopId) {
      return `/shop/${shopId}`;
    }
    // Warna root pe
    return '/';
  };

  // ✅ Extract shopId from location if params not available
  const getShopIdFromPath = () => {
    if (shopId) return shopId;
    const match = location.pathname.match(/\/shop\/(\d+)/);
    return match ? match[1] : null;
  };

  useEffect(() => {
    // ✅ Prevent double popup (React strict mode)
    if (hasShownPopupRef.current || showingPopup) return;

    hasShownPopupRef.current = true;
    setShowingPopup(true);

    const confirmLogout = async () => {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: 'Do you really want to logout?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#004aad',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, logout',
        cancelButtonText: 'Cancel',
        allowOutsideClick: false,
        allowEscapeKey: false,
        reverseButtons: true,
        focusCancel: true
      });

      if (result.isConfirmed) {
        // ✅ Clear all storage safely
        try {
          localStorage.clear();
          sessionStorage.clear();
        } catch (err) {
          console.error('Error clearing storage:', err);
        }

        // ✅ Call onLogout callback if provided
        try {
          if (typeof onLogout === 'function') {
            onLogout();
          }
        } catch (err) {
          console.error('Error in onLogout callback:', err);
        }

        // ✅ Redirect to signin (full reload to clear state)
        window.location.href = '/signin';
      } else {
        // ✅ Safe back navigation
        const currentShopId = getShopIdFromPath();

        // Check if there's history to go back to
        if (window.history.length > 1) {
          navigate(-1);
        } else if (currentShopId) {
          navigate(`/shop/${currentShopId}`, { replace: true });
        } else {
          navigate('/', { replace: true });
        }
      }
    };

    confirmLogout();

    // ✅ Cleanup function
    return () => {
      // Kuch cleanup zaroori nahi — bas memory leak se bachne ke liye
    };
  }, [navigate, onLogout, shopId, showingPopup, location.pathname]);

  // ✅ Kuch bhi render nahi karega — sirf popup handle karega
  return null;
};

export default Logout;